/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const SalesAnalytics: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M20.7308 5H16.0577C15.9289 5 15.8269 5.04806 15.75 5.14419C15.6538 5.23456 15.6058 5.34028 15.6058 5.46141C15.6058 5.58253 15.6538 5.69215 15.75 5.78828L17.1923 7.23981L13.9519 10.4891L12.2596 8.79713C11.9962 8.53374 11.6788 8.40304 11.3077 8.40304C10.9365 8.40304 10.6192 8.53374 10.3558 8.79713L5.38462 13.7575L7.28847 15.6609L11.3077 11.6522L13 13.3441C13.2692 13.6075 13.5904 13.7383 13.9615 13.7383C14.3269 13.7383 14.6404 13.6075 14.9039 13.3441L19.0962 9.15283L20.4135 10.4794C20.4904 10.5755 20.5962 10.6236 20.7308 10.6236C20.8519 10.6236 20.9558 10.5851 21.0385 10.5082C21.1346 10.4121 21.1827 10.2968 21.1827 10.1622V5.46141C21.1827 5.34028 21.1346 5.23456 21.0385 5.14419C20.9558 5.04806 20.8538 5 20.7308 5ZM22 20.3039V18.7273H3.57693V5.03849H2V19.5156C2 19.7329 2.08077 19.9233 2.24038 20.0828C2.38846 20.2309 2.57116 20.3039 2.78847 20.3039H22Z" />

    </StyledIconBase>
  )
})

SalesAnalytics.displayName = 'SalesAnalytics'

export const SalesAnalyticsDimensions = {height: 24, width: 24}
